<div class="adf-comments-container">
  <div id="comment-header" class="adf-comments-header adf-comments-divider">
    {{ 'COMMENTS.HEADER' | translate: {count: comments?.length} }}
  </div>
  <div *ngIf="!readOnly" class="adf-comments-input-container adf-comments-divider">
    <!--
      `subscriptSizing="dynamic"` : par defaut MDC reserve en permanence la hauteur d'une ligne
      d'indication sous le champ, meme sans hint ni erreur. Dans un panneau lateral etroit, cela
      fait un vide inexplique sous chaque zone de saisie.
    -->
    <mat-form-field subscriptSizing="dynamic">
                <textarea
                  matInput
                  id="comment-input"
                  [attr.aria-label]="'COMMENTS.ADD' | translate"
                  placeholder="{{'COMMENTS.ADD' | translate}}"
                  [(ngModel)]="message"
                  (keydown.escape)="clearMessage($event)"
                >
                </textarea>
    </mat-form-field>

    <div class="adf-comments-input-actions">
      <button
        mat-button
        class="adf-comments-input-add"
        data-automation-id="comments-input-add"
        color="primary"
        (click)="addComment()"
        [disabled]="!message"
      >
        {{ 'COMMENTS.ADD' | translate }}
      </button>
    </div>
  </div>

  <mat-list class="adf-comment-list">
    <mat-list-item *ngFor="let comment of comments"
                   (click)="selectComment(comment)"
                   class="adf-comment-list-item" style="display: block; width: 100%">
      <div class="adf-comment-img-container">
        <div *ngIf="!comment.hasAvatarPicture" class="adf-comment-user-icon">{{ comment.userInitials }}</div>
        <img *ngIf="comment.hasAvatarPicture" class="adf-people-img"
             [alt]="'COMMENTS.PROFILE_IMAGE' | translate"
             [src]="getUserImage(comment.createdBy)"/>
      </div>
      <div class="adf-comment-contents">
        <div matLine class="adf-comment-user-name" style="display: flex; width: 100%; justify-content: space-between">
          <span>{{ comment.userDisplayName }}</span>
          <div>
            <mat-icon *ngIf="comment.createdBy.id === currentUserId" style="cursor: pointer;" (click)="openEdit(comment)">edit</mat-icon>
            <mat-icon *ngIf="comment.createdBy.id === currentUserId" style="cursor: pointer;" (click)="deleteComment(comment)">delete</mat-icon>
          </div>
        </div>
        <div *ngIf="commentInEdit !== comment" matLine class="adf-comment-message">{{ comment.message }}</div>
        <div *ngIf="commentInEdit === comment && comment.createdBy.id === currentUserId">
          <!--
      `subscriptSizing="dynamic"` : par defaut MDC reserve en permanence la hauteur d'une ligne
      d'indication sous le champ, meme sans hint ni erreur. Dans un panneau lateral etroit, cela
      fait un vide inexplique sous chaque zone de saisie.
    -->
    <mat-form-field subscriptSizing="dynamic">
                <textarea
                  matInput
                  id="comment-input-edit"
                  [attr.aria-label]="'Editer le commentaire'"
                  placeholder="Editer le commentaire"
                  [(ngModel)]="messageEdit"
                  (keydown.escape)="clearMessage($event)">
                </textarea>
          </mat-form-field>
          <div class="adf-comments-input-actions">
            <button
              mat-button
              class="adf-comments-input-add"
              data-automation-id="comments-input-add"
              color="primary"
              (click)="editComment(comment)"
              [disabled]="!messageEdit">
              Editer
            </button>
          </div>
        </div>

        <div matLine class="adf-comment-message-time">{{ comment.created | adfTimeAgo }}</div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
